import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetSuspectedManipulationUseCaseInterface } from 'domain/usecases';

export class RemoteGetSuspectedManipulation
  implements GetSuspectedManipulationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetSuspectedManipulationUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetSuspectedManipulationUseCaseInterface.Params,
  ): Promise<GetSuspectedManipulationUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, { ...params });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
